// extracted by mini-css-extract-plugin
export default {"container":"LoadingElement_container__Rp5jy","image":"LoadingElement_image__NQYIt"};